Customer.Ticket ||= {}

class Customer.Ticket.InteractionScheduleImpactedDetailsView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/interaction_schedule/interaction_schedule_impacted_details']
  className: 'interaction-schedule-details impacted'

  initialize: (@options = {}) ->
    @schedule = @options.schedule

  render: ->
    @$el.html(@template(@schedule))
    @
